// 미디어 센터 섹션 — /blog/:section
// '전체'(/blog)와 같은 화면을 쓰고, 해당 섹션 탭만 활성이 된다(MediaCenterView).
import { useParams } from 'react-router-dom';
import { MediaCenterView } from '../features/MediaCenter/MediaCenterView';

export function BlogSectionPage() {
  const { section } = useParams();
  // key — 섹션 간 이동(/blog/a → /blog/b)은 같은 라우트 엘리먼트라 remount 가 안 일어난다.
  // key 를 줘야 검색어·정렬·페이지가 새 섹션에서 초기값으로 시작한다(MediaCenterView 호출 규약).
  return <MediaCenterView key={section} sectionSlug={section} />;
}
